var map = {
	"./auth.tpl.html": "o+TT",
	"./deckWrapper.tpl.html": "sd88",
	"./endPresentation.tpl.html": "NXxq",
	"./menuEditor.tpl.html": "JLCu",
	"./menuPresentations.tpl.html": "WB9H",
	"./menuUser.tpl.html": "RO9y",
	"./quoteChooser.tpl.html": "vBMh",
	"./themeChooser.tpl.html": "ocNX",
	"./welcomeIntro.tpl.html": "v540",
	"./welcomeStep.tpl.html": "s1RJ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sQ2k";